import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.webp";

type LinkType = {
  name: string;
  path: string;
  href: string;
  target?: string;
  active?: boolean;
};

const links: LinkType[] = [
  {
    name: "Home",
    path: "/",
    href: "#",
    active: false,
  },
  {
    name: "About Me",
    path: "/about-us",
    href: "#",
    active: false,
  },
  // {
  //   name: "Experience",
  //   path: "/experience",
  //   href: "#",
  //   active: false,
  // },
  {
    name: "Blog",
    path: "/blogs",
    href: "#",
    active: false,
  },
];

const Nav = () => {
  const [navLinks, setNavLinks] = useState<LinkType[]>(links);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [page, setPage] = useState("Home");

  const setActiveNav = (pageName: string) => {
    const newNavLinks = links.map((item) => {
      item.active = false;
      if (item.name === pageName) {
        item.active = true;
      }
      return item;
    });
    setNavLinks(newNavLinks);
  };

  useEffect(() => {
    links.forEach((item) => {
      if (item.path === location.pathname) {
        setActiveNav(item.name);
      }
    });

    if (window.location.pathname === "/" && window.location.hash === "") {
      setActiveNav("Home");
    }

    setPage(window.location.pathname.split("/")[1]);
  }, [location]);

  return (
    <div className="mx-auto max-w-screen-2xl ">
      <div className="py-6 ">
        <nav className="flex gap-2 xl:gap-40 items-center sm:pt-10 px-5 md:px-10 lg:px-16 xl:px-20">
          <div className="flex gap-10 justify-between">
            <Link to="/" className="relative z-50">
              <img src={logo} alt="logo" className="h-14" />
              {/* <h2 className="montserrat-subrayada-regular  text-2xl">
                <span className="text-primary montserrat-subrayada-bold ">
                  john
                </span>
                bostjancic
              </h2> */}
            </Link>
            <div className="flex items-center -mr-2 lg:hidden">
              <button
                className="inline-flex items-center justify-center p-2 text-gray-400 bg-gray-50 rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-50"
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  aria-hidden="true"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </button>
            </div>
            <div></div>
          </div>
          <div className="hidden lg:flex md:space-x-5 xl:space-x-10 list-none montserrat-medium items-center">
            {navLinks.map((link, index) => (
              <div className="relative z-10 group" key={index}>
                <Link
                  to={link.path}
                  key={link.name}
                  onClick={() => setActiveNav(link.name)}
                  className="text-base hover:text-primary transition-all duration-200 list-none "
                >
                  {link.name}
                </Link>
                <div
                  className={`absolute top-6 h-1 rounded-full bg-primary transition-all duration-500 ease-in-out ${
                    link.active ? "w-[60%]" : "w-0 group-hover:w-[60%] "
                  }`}
                ></div>
              </div>
            ))}
          </div>
        </nav>
        <div
          className={`${
            isOpen
              ? " flex flex-col gap-4 px-10 md:px-14 montserrat-medium "
              : "hidden"
          }`}
        >
          {navLinks.map((link, index) => (
            <div className="relative z-10" key={index}>
              <Link
                to={link.path}
                key={link.name}
                onClick={() => setActiveNav(link.name)}
                className="text-base  text-black hover:text-primary transition-all duration-200 list-none "
              >
                {link.name}
              </Link>
              {link.active && (
                <div className="absolute -z-20 top-6 w-[10%] h-1 rounded-full bg-primary"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Nav;
